import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from '@material-ui/core/Button';
import { tokens } from '../../theme';

const useStyles = makeStyles((theme) => ({
    root: {
        border: `1px solid ${tokens.border}`,
        borderRadius: tokens.radius,
        backgroundColor: tokens.surface,
        padding: theme.spacing(3),
    },
    title: {
        fontSize: '0.75rem',
        fontWeight: 700,
        letterSpacing: '0.12em',
        textTransform: 'uppercase',
        color: tokens.muted,
        margin: `0 0 ${theme.spacing(2)}px`,
        paddingBottom: theme.spacing(1.5),
        borderBottom: `1px solid ${tokens.border}`,
    },
    row: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacing(1),
    },
    label: {
        '& .MuiFormControlLabel-label': {
            fontSize: '0.9375rem',
            color: tokens.inkSoft,
        },
        marginRight: 0,
    },
    count: {
        fontSize: '0.75rem',
        fontWeight: 700,
        color: tokens.muted,
        backgroundColor: tokens.blue50,
        borderRadius: 10,
        padding: '2px 8px',
        flexShrink: 0,
    },
    empty: {
        color: tokens.muted,
        fontSize: '0.9375rem',
        margin: 0,
    },
    clear: {
        marginTop: theme.spacing(2),
    },
}));

/** Category facet list for the publications listing. */
export default function PublicationSidebar({
    categories = [],
    selectedCategories = [],
    onToggle,
    onClear,
}) {
    const classes = useStyles();

    return (
        <aside className={classes.root} aria-label="Filter publications by category">
            <p className={classes.title}>Category</p>

            {categories.length === 0 && (
                <p className={classes.empty}>No categories available.</p>
            )}

            {categories.map((category) => (
                <div className={classes.row} key={category.name}>
                    <FormControlLabel
                        className={classes.label}
                        control={
                            <Checkbox
                                color="primary"
                                size="small"
                                checked={selectedCategories.includes(category.name)}
                                onChange={() => onToggle(category.name)}
                            />
                        }
                        label={category.name}
                    />
                    <span className={classes.count}>{category.count}</span>
                </div>
            ))}

            {selectedCategories.length > 0 && onClear && (
                <Button className={classes.clear} size="small" onClick={onClear}>
                    Clear filters
                </Button>
            )}
        </aside>
    );
}
